import AreaSourceTypeSelect from "components/common/panel/AreaSourceTypeSelect";
import styled from "styled-components";
import { PlaySource, SourceType } from "type/panel/Panel.type";
import PanelUpload from "../PanelUpload";
import { Button, TextField } from "@mui/material";
import {
  fieldRefNumberGet,
  sourceFieldsFileNameDefault,
  sourceFieldsStateDefault,
} from "./AreaSourceFields.logic";
import { useEffect, useRef, useState } from "react";
import { SOURCE_TYPE_VALUES } from "constant/panel";
import InputField from "components/UI/InputField";

type Props = {
  defaultSourceFields: PlaySource | null;
  onSourceFieldsUpdate: Function;
  onCancel: Function;
};

const AreaSourceFields = ({
  defaultSourceFields,
  onSourceFieldsUpdate,
  onCancel,
}: Props) => {
  const [sourceFields, setSourceFields] = useState<PlaySource>(
    sourceFieldsStateDefault(defaultSourceFields)
  );
  const [sourceType, setSourceType] = useState<SourceType | "">(
    SOURCE_TYPE_VALUES.TEXT
  );
  const contentRef = useRef<HTMLTextAreaElement>(null);
  const durationRef = useRef<HTMLInputElement>(null);
  const startRef = useRef<HTMLInputElement>(null);
  const waitRef = useRef<HTMLInputElement>(null);
  const repeatRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState<string>(
    sourceFieldsFileNameDefault(defaultSourceFields)
  );

  useEffect(() => {
    if (defaultSourceFields !== null) {
      setSourceType(defaultSourceFields.type);
    }
  }, [defaultSourceFields]);

  const sourceTypeChange = (ev: any) => {
    const selectedType: SourceType | "" = ev.target.value;
    setSourceType(selectedType);
    console.log("sourceTypeChange", ev.target.value);
  };

  const saveSourceHandle = () => {
    console.log("saveSourceHandle", contentRef.current?.value);
    const nextSourceFields: PlaySource = { ...sourceFields };
    const content: string = contentRef.current ? contentRef.current.value : "";
    const duration: number = fieldRefNumberGet(durationRef);
    const start: number = fieldRefNumberGet(startRef);
    const wait: number = fieldRefNumberGet(waitRef);
    const repeat: number = fieldRefNumberGet(repeatRef);
    if (sourceType !== "") {
      nextSourceFields.type = sourceType;
    }
    nextSourceFields.content = content;
    nextSourceFields.duration = duration;
    nextSourceFields.start = start;
    nextSourceFields.wait = wait;
    nextSourceFields.repeat = repeat;
    nextSourceFields.fileName = fileName;
    onSourceFieldsUpdate(nextSourceFields);
    if (
      defaultSourceFields === null &&
      contentRef.current &&
      durationRef.current &&
      startRef.current &&
      waitRef.current &&
      repeatRef.current
    ) {
      contentRef.current.value = "";
      durationRef.current.value = "0";
      startRef.current.value = "0";
      waitRef.current.value = "0";
      repeatRef.current.value = "1";
    }
  };

  const fileUploadHandle = (res: any) => {
    console.log("res f up", res.files[0].filename);
    const newFileName = res.files[0].filename;
    setFileName(newFileName);
  };

  return (
    <Div>
      <AreaSourceTypeSelect value={sourceType} onChange={sourceTypeChange} />

      {sourceType !== SOURCE_TYPE_VALUES.TEXT && (
        <>
          <FileTypeDiv>
            <DivField>
              <PanelUpload fileUploadHandle={fileUploadHandle} />
            </DivField>
          </FileTypeDiv>
          <DivField>previous file name: {sourceFields.fileName}</DivField>
        </>
      )}

      {sourceType === SOURCE_TYPE_VALUES.TEXT && (
        <TextTypeDiv>
          <DivField>
            <Textarea ref={contentRef} defaultValue={sourceFields.content} />
          </DivField>
        </TextTypeDiv>
      )}
      <DivField>
        <span>Duration: </span>
        <input
          type="text"
          ref={durationRef}
          defaultValue={sourceFields.duration}
        />
      </DivField>
      {/* <DivField>
        <span>Start: </span>
        <input type="text" ref={startRef} defaultValue={sourceFields.start} />
      </DivField> */}
      {/* <DivField>
        <span>Wait: </span>
        <input type="text" ref={waitRef} defaultValue={sourceFields.wait} />
      </DivField>
      <DivField>
        <span>Repeat: </span>
        <input type="text" ref={repeatRef} defaultValue={sourceFields.repeat} />
      </DivField> */}
      <Button onClick={saveSourceHandle}>Save source</Button>
      <Button onClick={() => onCancel()}>Cancel</Button>
    </Div>
  );
};

const Div = styled.div``;

const TextTypeDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const FileTypeDiv = styled.div`
  display: flex;
`;

const Textarea = styled.textarea`
  margin-top: 0.5rem;
  width: 30rem;
  height: 5rem;
`;

const DivField = styled.div`
  margin-top: 1rem;
`;

export default AreaSourceFields;
